<template>
  <div class="consultPop">
    <img src="@/assets/images/cancle-icon.png" alt="" class="concle-btn" @click="closePop">
    <div class="content">
      <div class="content-top">在线咨询</div>
      <!-- <div class="relation-tel">
        <div class="relation-tel-img">
          <img src="@/assets/images/qq.png" alt="">
        </div>
        <div class="relation-tel-word">在线客服</div>
      </div> -->
      <div class="relation-tel">
        <div class="relation-tel-img">
          <img src="@/assets/images/phnoc-icon.png" alt="">
        </div>
        <div class="relation-tel-word">6210088</div>
      </div>
      <!-- <div class="relation-tel relation-tel1">
        <div class="relation-tel-img">
          <img src="@/assets/images/wechat.png" alt="">
        </div>
        <div class="relation-tel-word">微信二维码</div>
      </div>
      <div class="qr-img">
        <img src="@/assets/images/QR-code.png" alt="">
      </div> -->
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {}
  },
  mounted() {},
  methods: {
    closePop() {
      this.$emit('closePop')
    }
  }
}

</script>

<style lang="scss" scoped>
.consultPop {
  width: 200px;
  height: max-content;
  position: inherit;
  .concle-btn {
    position: absolute;
    top: -24px;
    right: -24px;
    width: 24px;
    height: 24px;
    cursor: pointer;
  }
  .content {
    width: 100%;
    max-height: 365px;
    border: 1px solid #cfcfcf;
    border-radius: 15px;
    background-color: #fff;
    .content-top {
      border-top-left-radius: 15px;
      border-top-right-radius: 15px;
      font-size: 14px;
      text-align: center;
      font-weight: 600;
      padding: 10px 0px;
      background: #f5f5f5;
    }
    .relation-tel {
      padding: 15px 0px;
      align-items: center;
      display: flex;
      width: 100%;
      // border-bottom: 1px solid #efefef;
      cursor: pointer;
      .relation-tel-img {
        flex: 0 0 50px;
        text-align: center;
      }
      .relation-tel-word {
        font-size: 14px;
      }
    }
    .relation-tel1 {
      padding: 5px 0;
      border: 0;
    }
    .qr-img {
      width: 150px;
      height: 150px;
      overflow: hidden;
      margin: 6px auto 15px auto;
      img {
        width: 100%;
        height: 100%;
      }
    }
  }
}
</style>